function getApiRoot() {
    const root = localStorage.getItem('APIROOT');
    return root ? root : process.env.REACT_APP_API_ROOT;
}

function getSSORoot() {
    const root = localStorage.getItem('SSOROOT');
    return root ? root : process.env.REACT_APP_SSO_ROOT;
}

const urls = {
    API_ROOT: getApiRoot(),
    SSO_ROOT: getSSORoot()
};

export default urls;


// WEBPACK FOOTER //
// ./src/utils/urls.js